// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3b65K","requiredAsterisk":"Info_requiredAsterisk__11nnD"};